import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import Asset from '@/model/dataLayer/api/MembershipSystem/Asset'
import UserMembership from '@/model/dataLayer/api/MembershipSystem/UserMembership'

const entity = {
  actionDisplay: {
    displayName: 'Status',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  actionBy: {},
  actionSource: {},
  assetId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        showButton: true,
        selectItems: async () => { return await Asset.getList(true) },
        itemText: 'name',
        itemValue: 'id'
      }
    }
  },
  userId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        showButton: true,
        selectItems: async () => { return await UserMembership.getList(true) },
        itemText: 'username',
        itemValue: 'userId'
      }
    }
  },
  note: {}
}
const config = {
  load: async function (filter) {
    const assetId = filter[0].assetId
    return (await hillo.get(cloudV2Url + 'api/assets/' + assetId + '/logs')).content.map(it => {
      it.actionDisplay = it.action
      return it
    })
  }
}
export default IKDataEntity.ModelFactory(entity, config)
export async function getAssetLog (assetId) {
  return (await hillo.get(cloudV2Url + 'api/assets/' + assetId + '/logs'))
}
